import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { indexedDB } from '../../indexedDB'
import { PendingBulkRequest } from './schema'

type CreateMutationOptions = UseMutationOptions<
  PendingBulkRequest | undefined,
  unknown,
  Omit<PendingBulkRequest, 'id'>
>

export const useCreatePendingBulkRequest = (
  options?: CreateMutationOptions
) => {
  return useMutation({
    ...options,
    mutationFn: async (params) => {
      const newRecordId = await indexedDB.pendingBulkRequests.add(params)

      return indexedDB.pendingBulkRequests.get(newRecordId)
    },
  })
}
